import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Download, X } from 'lucide-react'
import { useInstallPrompt } from '../../hooks/useInstallPrompt'
import { trackEvent } from '../../utils/analytics'
import { IOSInstallGuide } from './IOSInstallGuide'

export function InstallBanner() {
  const { canInstall, isIOS, install, dismiss } = useInstallPrompt()
  const [showIOSGuide, setShowIOSGuide] = useState(false)

  if (!canInstall) return null

  const handleInstall = async () => {
    if (isIOS) {
      trackEvent('btv_pwa_ios_guide_view')
      setShowIOSGuide(true)
    } else {
      trackEvent('btv_pwa_install_click')
      await install()
    }
  }

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        className="fixed bottom-4 left-4 right-4 z-40 mx-auto max-w-md"
      >
        <div className="glass-card rounded-2xl p-4 border border-turquoise/20 shadow-lg">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-turquoise/20 flex items-center justify-center shrink-0">
              <Download className="w-5 h-5 text-turquoise" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-white text-sm">Instalar BT Vision</p>
              <p className="text-xs text-white/50 mt-0.5">
                Acesse mais rápido direto da tela inicial
              </p>
            </div>
            <button
              onClick={() => { trackEvent('btv_pwa_banner_dismiss'); dismiss() }}
              className="p-1.5 text-white/40 hover:text-white/60 hover:bg-white/10 rounded-lg transition-colors shrink-0"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          <button
            onClick={handleInstall}
            className="mt-3 w-full py-2.5 rounded-xl bg-turquoise hover:bg-turquoise/80 text-white text-sm font-medium transition-colors"
          >
            {isIOS ? 'Ver instruções' : 'Instalar'}
          </button>
        </div>
      </motion.div>

      {/* iOS Instructions Modal */}
      <AnimatePresence>
        {showIOSGuide && (
          <IOSInstallGuide
            onClose={() => setShowIOSGuide(false)}
            onConfirm={() => {
              trackEvent('btv_pwa_ios_guide_dismiss')
              setShowIOSGuide(false)
              dismiss()
            }}
          />
        )}
      </AnimatePresence>
    </>
  )
}
